import { useStore } from "@nanostores/react"

import { TokenAmountBlock, TokenAmountBlockProps } from "./TokenAmountBlock"
import { ConvertedAmountBlock } from "./ConvertedAmountBlock"
import { $usdCurrency } from "../stores/currency-store"
import { nativeTokenInfo } from "../utils/native-token"

export function TokenAmountInCurrency(props: TokenAmountBlockProps) {
  const { amount, tokenId, ...rest } = props

  const useCurrency = useStore($usdCurrency)

  if (useCurrency) {
    return (
      <ConvertedAmountBlock
        amount={amount}
        hideCopyToClipboard
        needsParsing
        tokenId={tokenId}
        {...rest}
      />
    )
  }

  return (
    <TokenAmountBlock
      amount={amount}
      tokenId={tokenId}
      showTicker
      hideCopyToClipboard
      needsParsing
      {...rest}
    />
  )
}
